
      if (!window.__blockAppMount) {
        import('/src/app/main.ts');
      } else {
        console.log('App bootstrap blocked in inline webview');
      }
    